import "./DraftEmployeesLayout.css";

import {
	BackdropCircularProgress,
	RequestParams,
} from "@websential/cosmic-v20";
import { Box, CircularProgress, Toolbar, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReactSeverity,
	addDashesInSIN,
	formatAmountCommaSeperator,
	formatDate,
	formatDateToShow,
	formatPhoneNo,
	getDDLLabelByValue,
	getDDLValueByLabel,
	getProvinceDDLValueByShortCode,
	showDashesInSIN,
	useNavigateToLogout,
} from "../../common/Common";
import { GridRenderCellParams, GridRowSelectionModel } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { CountryService } from "../../services/common/CountryService";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { IAppState } from "../../store/reducers";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import SearchIcon from "@mui/icons-material/Search";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useStickyDataTableHeader } from "../../common/useStickyDataTableHeader";

let emptyEmpDraft = {
	id: null,
	employeeId: "",
	clientId: "",
	firstName: "",
	lastName: "",
	initial: "",
	gender: 200,
	dateOfBirth: null,
	socialInsuranceNumber: undefined,
	country: null,
	province: null,
	states: null,
	address: "",
	city: "",
	postCode: "",
	phone: "",
	email: "",
	stubLanguage: 100,
	emailStub: 100,
	printHourlyRateOnStub: 100,
	stubNotes: "",
	account1Name: "",
	accountNo: "",
	branchTransitNumber: "",
	bankFinancialNo: "",
	account2Name: "",
	account2No: "",
	branchTransitNumberForAccount2: "",
	bankFinancialNoForAccount2: "",
	split: 100,
	percenagePerDollorInAccount1: 0,
	payFrequency: null,
	howIsEmployPaid: null,
	dateOfHire: "",
	payMethod: 200,
	provinceOfEmployment: null,
	includeInT4OrRl1: 100,
	dentalBenefits: 0,
	vacationPay: 100,
	payOutVacationPay: 100,
	vacationPayOpenBalance: 0,
	datePensionBecomePayable: "",
	rppOrDpspRegistrationNumber: "",
	dateOfDisability: "",
	dateDisabilityWasCeased: "",
	regularSalaryForThePeriod: null,
};

export interface IDraftEmployeeDataGridDataTable {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	showSettingColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	whiteSpace?: any;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	provinceOfEmployementDDL?: any;
	countryList?: any;
	provinceOrStateDDL?: any;
	employeeDraftListTableData: (data: any) => void;
	payFrequencyDDLItems?: any
	companyInformation?: any
}

export const DraftEmployeeDataGrid: React.FC<
	IDraftEmployeeDataGridDataTable
> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	showSettingColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	countryList,
	provinceOfEmployementDDL,
	employeeDraftListTableData,
	payFrequencyDDLItems,
	companyInformation
}) => {
		const isInitialRequest = useRef(true);
		const [loading, setLoading] = useState(false);
		const navigateToLogout = useNavigateToLogout();
		const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
		const [employeeDraftListItems, setEmployeeDraftListItems] =
			useState<any>(undefined);
		const [empDraft, setEmpDraft] = useState(emptyEmpDraft);

		useEffect(() => {
			// if (
			// 	rows &&
			// 	JSON.stringify(rows) !== JSON.stringify(employeeDraftListItems)
			// ) {
			if (!isEqual(rows, employeeDraftListItems)) {
				setEmployeeDraftListItems(rows);
			}
		}, [rows]);

		// useEffect(() => {
		// 	employeeDraftListTableData(employeeDraftListItems);

		// }, [employeeDraftListItems]);

		useEffect(() => {
			if (employeeDraftListItems && employeeDraftListItems.length > 0) {
				employeeDraftListTableData(employeeDraftListItems);

			}
		}, [employeeDraftListItems]);

		const theme = useTheme();
		const [itemSearch, setItemSearch] = useState("");
		const [requestParams, setRequestParams] = useState<any>({
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			sortField: null,
			sortOrder: "asc",
			searchQuery: "",
			filters: {
				name: { value: "", matchMode: "contains" },
				"country.name": { value: "", matchMode: "contains" },
				company: { value: "", matchMode: "contains" },
				"representative.name": { value: "", matchMode: "contains" },
			},
		});

		const [selectedItems, setSelectedItems] = useState<any>([]);
		const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);

		const [itemSearsch, setItemSearsch] = useState("");
		const onSearchButtonClicked = () => {
			setLoading(true);
			setRequestParams((prevParams: any) => ({
				...prevParams,
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				searchQuery: itemSearch,
			}));
			if (changeLoginForGetEmptyItemsBySearchQuery) {
				changeLoginForGetEmptyItemsBySearchQuery(false);
			}
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		};
		const handleClearSearch = () => {
			setLoading(true);
			setItemSearch("");
			setRequestParams((prevParams: any) => ({
				...prevParams,
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				searchQuery: "",
			}));
			if (changeLoginForGetEmptyItemsBySearchQuery) {
				changeLoginForGetEmptyItemsBySearchQuery(false);
			}
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		};

		const findIndexById = (id: string | number | any) => {
			let index = -1;

			for (let i = 0; i < employeeDraftListItems.length; i++) {
				if (employeeDraftListItems[i].id === id) {
					index = i;
					break;
				}
			}

			return index;
		};

		const createId = () => {
			let id = "";
			let chars =
				"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

			for (let i = 0; i < 5; i++) {
				id += chars.charAt(Math.floor(Math.random() * chars.length));
			}

			return id;
		};

		// const openNew = () => {
		// 	// alert("new")

		// 	let _employeeDraftListItems = [...employeeDraftListItems];
		// 	let _empDraft: any = { ...empDraft };

		// 	if (empDraft.id) {
		// 		const index = findIndexById(empDraft.id);

		// 		_employeeDraftListItems[index] = _empDraft;
		// 	} else {
		// 		_empDraft.id = createId();
		// 		_employeeDraftListItems.push(_empDraft);
		// 	}



		// 	// setEmployeeDraftListItems((prev: any) => {
		// 	// 	const updated = [...prev, { ...emptyEmpDraft }];
		// 	// 	employeeDraftListTableData(updated); // call directly here
		// 	// 	return updated;
		// 	// });
		// 	setEmployeeDraftListItems(_employeeDraftListItems)
		// 	setEmpDraft(emptyEmpDraft);
		// };

		const openNew = () => {

			let _employeeDraftListItems = [...employeeDraftListItems];
			let _empDraft: any = { ...empDraft };

			if (empDraft.id) {
				const index = findIndexById(empDraft.id);

				_employeeDraftListItems[index] = _empDraft;
			} else {
				const newRowId = createId();
				_empDraft.id = newRowId;

				_employeeDraftListItems.push(_empDraft);
				setLastAddedRowId(newRowId && newRowId);


				// _empDraft.id = createId();
				// _employeeDraftListItems.push(_empDraft);

			}
			setEmployeeDraftListItems(_employeeDraftListItems)
			setEmpDraft(emptyEmpDraft);
		};

		const renderHeader = () => {
			return (
				<div
					style={{
						display: "flex",
						// justifyContent:showGlobalSearch ? "space-between" : "end",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<div
						style={{
							fontSize: "1.5rem",
							fontWeight: "bold",
							fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
						}}
					>
						{pageTitle}
					</div>
					{showGlobalSearch && (
						<span
							className="p-input-icon-left w-3"
							style={{
								display: "flex",
								marginLeft: "auto",
								marginRight: "10px",
								height: "37px",
							}}
						>
							<i className="pi pi-search" />
							<InputText
								value={itemSearch}
								onChange={(e) => setItemSearch(e.target.value)}
								placeholder={
									searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
								}
								className="w-full"
								style={{ borderRadius: "2px 0px 0px 2px" }}
							/>
							{itemSearch && (
								<Button
									icon="pi pi-times"
									onClick={handleClearSearch}
									className="p-button-warning"
									style={{ borderRadius: 0 }}
								/>
							)}
							<Button
								onClick={onSearchButtonClicked}
								severity={EnhancedButtonPrimeReactSeverity.Secondary}
								style={{
									// padding:"8px 10px 8px 10px",
									padding: "10px 22px 10px 10px",
									// marginRight:"-14px!important",
									borderRadius: "0px 2px 2px 0px",
									// backgroundColor: theme.palette.primary.main
								}}
							>
								{/* <SearchIcon /> */}
								Search
							</Button>
						</span>
					)}
					<EnhancedButtonPrimeReact
						label="Add"
						// type="submit"
						onClickHandler={openNew}
						// icon="pi pi-check"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/>
					{/* {selectedItems.length > 0 ?
						(
						  <>
						<Button
						  icon="pi pi-trash"
						  onClick={() =>
							onRowDeleteClicked(selectedItems)
						  }
						  severity="danger"
						/>
						  </>
						):(<></>)} */}
					{/* {selectionToolbar && selectionToolbar(selectedItemsIds)} */}
					{selectionToolbar && selectionToolbar(selectedItems)}
				</div>
			);
		};
		const headerSearch = renderHeader();
		function search(_row: any) {
			return (
				rows &&
				rows.filter(
					(rows: any) =>
						rows.clientName.props.children
							.toLowerCase()
							.indexOf(itemSearsch.toLowerCase()) > -1
				)
			);
		}
		// Custom column for row indices
		const indexColumn = {
			body: (rowData: any, row: any) => {
				return <span>{row.rowIndex + 1}</span>; // +1 to start indexing from 1 instead of 0
			},
			header: "#",
		};

		const onPage = (event: any) => {
			// setRequestParams(event);
			setLoading(true);
			//imitate delay of a backend call
			setTimeout(() => {
				setRequestParams({
					...event,
					searchQuery: itemSearch,
				});
				setLoading(false);
			}, 1000);
		};
		const [sortField, setSortField] = useState(null);
		const [sortOrder, setSortOrder] = useState(1);
		const onSort = useCallback(
			(event: any) => {
				setLoading(true);

				let newSortOrder: any;
				if (event.sortField === sortField) {
					// Toggle sortOrder between 1 and -1
					newSortOrder = sortOrder === 1 ? -1 : 1;
					setSortOrder(newSortOrder);
				} else {
					// Set the new sortField and reset sortOrder to 1
					newSortOrder = 1;
					setSortField(event.sortField);
					setSortOrder(newSortOrder);
				}


				setRequestParams((prevParams: any) => ({
					...prevParams,
					sortOrder: newSortOrder !== 1 ? "asc" : "desc",
					sortField: event.sortField,
				}));

				// Imitate delay of a backend call
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			},
			[sortOrder, sortField]
		);
		// This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
		useEffect(() => {
			// if the results fetcher was passed, we can use it to fetch the results.
			if (onRequestParamsChange) {
				// skip the first initial call
				if (isInitialRequest.current === true) {

					isInitialRequest.current = false;
				} else {

					onRequestParamsChange(requestParams);
				}
			}
		}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

		useEffect(() => {
			if (requestParamsToInitial && requestParams.first !== initialPage) {
				setRequestParams({
					first: initialPage,
					rows: initialPageSize,
					page: initialPage,
					sortField: null,
					sortOrder: "asc",
					searchQuery: "",
					filters: {
						name: { value: "", matchMode: "contains" },
						"country.name": { value: "", matchMode: "contains" },
						company: { value: "", matchMode: "contains" },
						"representative.name": { value: "", matchMode: "contains" },
					},
				});

			}

		}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

		const onSelectionModelChange = useCallback(
			(items: any) => {

				let selectedItemsIds = items.value.map((item: any) => item.id);
				// const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				// 	return rows && rows.find((row: any) => row.id === selectedItem.id);
				// });
				const updatedSelectedItems = items.value && items.value
				setSelectedItems(updatedSelectedItems);
				setSelectedItemsIds(selectedItemsIds);
				// if (selectedRowsValues) {
				if (updatedSelectedItems.length > 0) {
					// const selectedRowData = rows.filter((row: any) => {
					// 	return items.value.includes(row);
					// });

					// selectedRowsValues(selectedRowData);


					selectedRowsValues(updatedSelectedItems);
				} else {
					selectedRowsValues(items.value);

				}
				// }
			},
			[rows, selectedRowsValues, selectedItems]
		);
		useEffect(() => {
			// Check for deleted items and remove them from selectedItems
			// const updatedSelectedItems =
			// 	selectedItems &&
			// 	selectedItems.length > 0 &&
			// 	selectedItems.filter((selectedItem: any) => {
			// 		return rows && rows.find((row: any) => row.id === selectedItem.id);
			// 	});
			const updatedSelectedItems =
				selectedItems &&
				selectedItems.length > 0 &&
				selectedItems
			// Only update if there are changes to selectedItems
			if (
				updatedSelectedItems &&
				updatedSelectedItems.length !== selectedItems.length
			) {
				setSelectedItems(updatedSelectedItems);

				// Update selectedItemsIds
				const updatedSelectedItemsIds = updatedSelectedItems.map(
					(item: any) => item.id
				);
				setSelectedItemsIds(updatedSelectedItemsIds);
			}
		}, [rows, selectedItems]);

		const onCellEditComplete = (e: any) => {
			const { rowData, newValue, field, originalEvent: event } = e;

			// Handle required field validation
			if (
				newValue === null ||
				(typeof newValue === "string" && newValue.trim().length === 0)
			) {
				event.preventDefault();
				return;
			}

			// Fields that can be assigned directly
			const directFields = new Set([
				"employeeId",
				"firstName",
				"lastName",
				"initial",
				"address",
				"email",
				"city",
				"vacationPayOpenBalance",
				"provinceOfEmployment",
				"gender",
				"country",
				"province",
				"postCode",
				"zipCode",
				"stubLanguage",
				"emailStub",
				"printHourlyRateOnStub",
				"payFrequency",
				"payMethod",
				"includeInT4OrRl1",
				"vacationPay",
				"payOutVacationPay",
				"dentalBenefits",
				"howIsEmployPaid",
				"regularSalaryForThePeriod",
				"initials",
				"dateOfBirth",
				"dateOfHire",
			]);

			if (directFields.has(field)) {
				rowData[field] = newValue;
			} else if (field === "dateOfHire") {
				rowData[field] = formatDate(newValue);
			} else if (field === "socialInsuranceNumber") {
				rowData[field] = addDashesInSIN(newValue);
			} else if (field === "phone") {
				rowData[field] = formatPhoneNo(newValue);
			}

			setEmployeeDraftListItems((prev: any[]) => [...prev]);
		};

		const cellEditor = (options: any) => {
			if (options.field === "employeeId") return textEditor(options);
			if (options.field === "firstName") return textEditor(options);
			if (options.field === "lastName") return textEditor(options);
			if (options.field === "initials") return textEditorForInitial(options);
			if (options.field === "gender") return genderDdlEditor(options);
			if (options.field === "dateOfBirth") return DateEditor(options);
			if (options.field === "dateOfHire") return DateEditor(options);
			if (options.field === "socialInsuranceNumber")
				return socialInsuranceNumberFieldEditor(options);
			if (options.field === "address") return textEditor(options);
			if (options.field === "email") return textEditor(options);
			if (options.field === "phone") return phoneNumberFieldEditor(options);
			// if (options.field === "country") return countryDDLFieldEditor(options);
			if (options.field === "province") return provinceDdlEditor(options);
			if (options.field === "city") return textEditor(options);
			if (options.field === "postCode")
				return postalCodeNumberFieldEditor(options);
			if (options.field === "zipCode") return zipCodeNumberFieldEditor(options);
			if (options.field === "stubLanguage") return stubLanguageDdlEditor(options);
			if (options.field === "emailStub") return emailStubDdlEditor(options);
			if (options.field === "printHourlyRateOnStub")
				return printHourlyRateOnStubDdlEditor(options);
			if (options.field === "payFrequency") return payFrequencyDdlEditor(options);
			if (options.field === "howIsEmployPaid") return howIsEmployPaidDdlEditor(options);
			if (options.field === "payMethod" && companyInformation && companyInformation.paymentSetup !== 100) return payMethodDdlEditor(options);
			if (options.field === "provinceOfEmployment") return poeDdlEditor(options);
			if (options.field === "country") return countryDdlEditor(options);
			if (options.field === "includeInT4OrRl1")
				return includeInT4OrRl1DdlEditor(options);
			if (options.field === "vacationPay") return vacationPayDdlEditor(options);
			if (options.field === "dentalBenefits")
				return dentalBenefitsDdlEditor(options);
			if (options.field === "payOutVacationPay")
				return payOutVacationPayDdlEditor(options);
			if (options.field === "vacationPayOpenBalance")
				return vacationPayOpenBalanceEditor(options);
			if (options.field === "regularSalaryForThePeriod")
				return regularSalaryForThePeriodEditor(options);
			else return <span>{options.value}</span>;
			// else return textEditor(options);
		};

		const textEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
				const value = e.target.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputText
					value={options.value}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
				/>
			);
		};
		const textEditorForInitial = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
				const value = e.target.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputText
					value={options.value}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
					maxLength={3}
					style={{ maxWidth: "70px!important" }}
				/>
			);
		};

		const socialInsuranceNumberFieldEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.target.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputMask
					value={options.value}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
					mask="999-999-999"
					unmask={true}
					autoClear={false}
				// className={renderErrorClass(options.column, options.rowIndex, rowData)}
				/>
			);
		};

		const phoneNumberFieldEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.target.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputMask
					value={options.value}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
					mask="(999) 999-9999"
					unmask={true}
					autoClear={false}
				/>
			);
		};
		// const SocialInsuranceNumberInput = ({
		// 	rowData,
		// 	field,
		// 	editorCallback,
		// }: any) => {
		// 	const [formattedValue, setFormattedValue] = useState(() =>
		// 		addDashesInSIN(rowData[field])
		// 	);

		// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		// 		const value = e.target.value;

		// 		setEmployeeDraftListItems((prev: any[]) => {
		// 			const updated = [...prev];
		// 			const index = updated.findIndex((item) => item.id === rowData.id);
		// 			if (index !== -1) {
		// 				updated[index] = { ...updated[index], [field]: value };
		// 			}
		// 			return updated;
		// 		});

		// 		editorCallback(value);
		// 		setFormattedValue(addDashesInSIN(value));
		// 	};

		// 	return (
		// 		<InputText
		// 			value={formattedValue}
		// 			onChange={handleChange}
		// 			onKeyDown={(e) => e.stopPropagation()}
		// 			maxLength={11}
		// 		/>
		// 	);
		// };

		// // In your DataTable column, use the component in the `editor` prop
		// const socialInsuranceNumberFieldEditor = (options: any) => {
		// 	return (
		// 		<SocialInsuranceNumberInput
		// 			rowData={options.rowData}
		// 			field={options.field}
		// 			editorCallback={options.editorCallback}
		// 		/>
		// 	);
		// };

		const genderDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Male", value: 200 },
						{ label: "Female", value: 100 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const stubLanguageDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "English", value: 100 },
						{ label: "French", value: 200 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const emailStubDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Yes", value: 200 },
						{ label: "No", value: 100 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const printHourlyRateOnStubDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Yes", value: 200 },
						{ label: "No", value: 100 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const payFrequencyDdlEditor = (options: any) => {
			const frequencyIdGetByFrequencyLabel = getDDLValueByLabel(payFrequencyDDLItems, options.value);
			options.value = frequencyIdGetByFrequencyLabel

			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={payFrequencyDDLItems ?? []}
					value={options.value}
					onChange={onChange}
					// placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		let howIsEmployPaidDDLItems = [
			{ label: "Fixed Salary", value: 200 },
			{ label: "By Hours", value: 100 }
		]
		const howIsEmployPaidDdlEditor = (options: any) => {
			// const howIsEmployeePaidIdGetByFrequencyLabel = getDDLValueByLabel(howIsEmployPaidDDLItems, options.value);
			// options.value = howIsEmployeePaidIdGetByFrequencyLabel

			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={howIsEmployPaidDDLItems ?? []}
					value={options.value}
					onChange={onChange}
					// placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const payMethodDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Cheque", value: 200 },
						{ label: "Direct Deposit", value: 300 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const includeInT4OrRl1DdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Yes", value: 200 },
						{ label: "No", value: 100 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const vacationPayDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Calculate", value: 100 },
						{ label: "Disable", value: 200 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const dentalBenefitsDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Not eligible", value: 100 },
						{ label: "Payee only", value: 200 },
						{ label: "Payee, Spouse, Children", value: 300 },
						{ label: "Payee, Spouse", value: 400 },
						{ label: "Payee, Children", value: 500 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const payOutVacationPayDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={[
						{ label: "Yes", value: 200 },
						{ label: "No", value: 100 },
					]}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		const vacationPayOpenBalanceEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				// <InputText
				// 	value={options.value}
				// 	onChange={handleChange}
				// 	onKeyDown={(e) => e.stopPropagation()}
				// 	maxLength={3}
				// />
				<InputNumber
					value={options.value}
					onChange={handleChange}
					placeholder="0.00"
					minFractionDigits={2}
					maxFractionDigits={2}
					inputStyle={{ textAlign: "right" }}
				/>
			);
		};
		const regularSalaryForThePeriodEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputNumber
					value={options.value}
					onChange={handleChange}
					placeholder="0.00"
					minFractionDigits={2}
					maxFractionDigits={2}
					inputStyle={{ textAlign: "right" }}
				/>
			);
		};
		// const [provinceDDL, setProvinceDDL] = useState(undefined);
		const provinceDdlEditor = (options: any) => {
			const { rowData, field } = options;
			// (async () => {
			// 	try {
			// 		const response = await CountryService.getProvinceOrStateDDL(
			// 			navigateToLogout,
			// 			rowData.country && rowData.country !== null && rowData.country,
			// 			"Province"
			// 		);

			// 		setProvinceDDL(response);
			// 		const provinceIdGetByPoeLabel = getDDLValueByLabel(response, options.value);
			// 		options.value = provinceIdGetByPoeLabel
			// 	} catch (err) {
			// 		console.error("error", err);
			// 	}
			// })();

			const provinceIdGetByPoeLabel = getDDLValueByLabel(provinceOfEmployementDDL, options.value);
			options.value = provinceIdGetByPoeLabel


			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					// options={provinceDDL && provinceDDL}
					options={provinceOfEmployementDDL || []}
					value={options.value}
					onChange={onChange}
					// placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
				/>
			);
		};
		// const countryDDLFieldEditor = (options: any) => {
		// 	const { rowData, field } = options;

		// 	const onChange = (e: any) => {
		// 		const newValue = e.value;

		// 		setEmployeeDraftListItems((prev: any[]) => {
		// 			const updated = [...prev];
		// 			const index = updated.findIndex((item) => item.id === rowData.id);
		// 			if (index !== -1) {
		// 				updated[index] = { ...updated[index], [field]: newValue };
		// 			}
		// 			return updated;
		// 		});

		// 		options.editorCallback(newValue);
		// 	};
		// 	return (
		// 		<Dropdown
		// 			options={countryList}
		// 			value={options.value}
		// 			onChange={onChange}
		// 			placeholder="--"
		// 			onKeyDown={(e) => e.stopPropagation()}
		// 			style={{ width: "100%" }}
		// 			disabled={!provinceOfEmployementDDL}
		// 		/>
		// 	);
		// };

		const postalCodeNumberFieldEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.target.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputMask
					value={options.value}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
					mask="a9a9a9"
					unmask={true}
					autoClear={false}
					style={{ textTransform: "uppercase" }}
				/>
			);
		};

		const zipCodeNumberFieldEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.target.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputMask
					value={options.value}
					onChange={handleChange}
					onKeyDown={(e) => e.stopPropagation()}
					mask="00000"
					unmask={true}
					autoClear={false}
				/>
			);
		};

		const poeDdlEditor = (options: any) => {
			const { rowData, field } = options;
			const poeIdGetByPoeLabel = getDDLValueByLabel(provinceOfEmployementDDL, options.value);
			options.value = poeIdGetByPoeLabel

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={provinceOfEmployementDDL || []}
					value={options.value}
					onChange={onChange}
					// placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
					disabled={!provinceOfEmployementDDL}
				/>
			);
		};

		const countryDdlEditor = (options: any) => {
			const { rowData, field } = options;

			const onChange = (e: any) => {
				const newValue = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newValue };
					}
					return updated;
				});

				options.editorCallback(newValue);
			};
			return (
				<Dropdown
					options={countryList || []}
					value={options.value}
					onChange={onChange}
					placeholder="--"
					onKeyDown={(e) => e.stopPropagation()}
					style={{ width: "100%" }}
					disabled={!countryList}
				/>
			);
		};


		const DateEditor = (options: any) => {
			const { rowData, field } = options;
			options.value = new Date(options.value)
			const handleChange = (e: any) => {
				const newDate = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex(
						(item) => item.id === rowData.id
					);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: newDate };
					}
					return updated;
				});

				options.editorCallback(newDate);
			};

			return (
				<div onClick={(e) => e.stopPropagation()}>
					<Calendar
						value={options.value}
						onChange={handleChange}
						dateFormat="M dd, yy"
						showButtonBar
						placeholder="M dd, yyyy"
					/>
				</div>
			);
		};

		const NumberFieldEditor = (options: any) => {
			const { rowData, field } = options;

			const handleChange = (e: any) => {
				const value = e.value;

				setEmployeeDraftListItems((prev: any[]) => {
					const updated = [...prev];
					const index = updated.findIndex((item) => item.id === rowData.id);
					if (index !== -1) {
						updated[index] = { ...updated[index], [field]: value };
					}
					return updated;
				});

				options.editorCallback(value);
			};

			return (
				<InputNumber
					value={options.value}
					onChange={handleChange}
					placeholder="0.00"
					minFractionDigits={2}
					maxFractionDigits={2}
					inputStyle={{ textAlign: "right" }}
				/>
			);
		};
		const columnsBody = (rowData: any, row: any, x: any) => {
			if (x.field === "provinceOfEmployment") {
				const selected = provinceOfEmployementDDL?.find(
					(item: { value: any }) => item.value === rowData[x.field]
				);
				return selected ? selected.label : rowData[x.field];
			} else if (x.field === "country") {
				const selected = countryList?.find(
					(item: { value: any }) => item.value === rowData[x.field]
				);
				return selected ? selected.label : rowData[x.field];
			} else if (x.field === "socialInsuranceNumber") {
				return <span>{rowData[x.field] && showDashesInSIN(rowData[x.field])}</span>;
			} else if (x.field === "socialInsuranceNumber") {
				return <span>{rowData[x.field] && formatPhoneNo(rowData[x.field])}</span>;
			} else if (x.field === "province") {
				const selected = provinceOfEmployementDDL?.find(
					(item: { value: any }) => item.value === rowData[x.field]
				);
				return selected ? selected.label : rowData[x.field];
			} else if (x.field === "dateOfHire" || x.field === "dateOfBirth") {
				return formatDateToShow(rowData[x.field]);
			} else if (x.field === "split") {
				return rowData[x.field] === 100
					? "No Split"
					: rowData[x.field] === 200
						? "Percentage"
						: rowData[x.field] === 300 ? "Fixed Amount" : "";
			} else if (x.field === "gender") {
				return rowData[x.field] === 200 ? "Male" : rowData[x.field] === 100 ? "Female" : "";
			} else if (x.field === "howIsEmployPaid") {
				return rowData[x.field] === 200 ? "Fixed Salary" : rowData[x.field] === 100 ? "By Hours" : "";
			} else if (x.field === "payFrequency") {
				return getDDLLabelByValue(payFrequencyDDLItems, rowData[x.field]);
				// return rowData[x.field];
			} else if (x.field === "payMethod") {
				return companyInformation && companyInformation.paymentSetup === 100 ? "Cheque" : rowData[x.field] === 100 ? "Cash" : rowData[x.field] === 200 ? "Cheque" : rowData[x.field] === 300 ? "Direct Deposit" : "";
			} else if (x.field === "vacationPay") {
				return rowData[x.field] === 100 ? "Calculate" : rowData[x.field] === 200 ? "Disable" : "";
			} else if (x.field === "payOutVacationPay") {
				return rowData[x.field] === 100 ? "No" : rowData[x.field] === 200 ? "Yes" : "";
			} else if (x.field === "includeInT4OrRl1") {
				return rowData[x.field] === 100 ? "No" : rowData[x.field] === 200 ? "Yes" : "";
			} else if (x.field === "dentalBenefits") {
				return rowData[x.field] === 100
					? "Not eligible"
					: rowData[x.field] === 200
						? "Payee only"
						: rowData[x.field] === 300
							? "Payee, Spouse, Children"
							: rowData[x.field] === 400
								? "Payee, Spouse"
								: rowData[x.field] === 500 ? "Payee, Children" : "";
			} else if (x.field === "sinStatus") {
				return rowData[x.field] === 100
					? "Pending"
					: rowData[x.field] === 200
						? "Refused"
						: rowData[x.field] === 300
							? "Failed to Provide"
							: rowData[x.field] === 400
								? "Recorded"
								: rowData[x.field] === 500 ? "Recorded Incorrect" : "";
			} else if (x.field === "stubLanguage") {
				return rowData[x.field] === 100 ? "English" : rowData[x.field] === 200 ? "French" : "";
			} else if (x.field === "emailStub") {
				return rowData[x.field] === 100 ? "No" : rowData[x.field] === 200 ? "Yes" : "";
			} else if (x.field === "printHourlyRateOnStub") {
				return rowData[x.field] === 100 ? "No" : rowData[x.field] === 200 ? "Yes" : "";
			} else if (x.field === "vacationPayOpenBalance" || x.field === "regularSalaryForThePeriod") {
				return <Typography sx={{ textAlign: "right", fontSize: ".875rem" }}>{formatAmountCommaSeperator(rowData[x.field])}</Typography>
			} else return <span>{rowData[x.field]}</span>;
		};

		const setting = () => {
			return (
				<div>
					<i className="pi pi-cog text-xl"></i>
				</div>
			);
		};


		const onDeleteNewAddedRow = (rowId: any) => {
			setEmployeeDraftListItems((prev: any[]) => {
				const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

				if (rowDeleteBasedOnId.length > 1) {
					const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
					setLastAddedRowId(lastRowId);
				} else {
					setLastAddedRowId(null);
				}
				return rowDeleteBasedOnId;
			});
		}

		const deleteRowColumn = (params: any, rowData: any, row: any) => {
			return (
				<EnhancedButtonPrimeReact
					icon="pi pi-times"
					onClickHandler={() => {
						if (!rowData.id || rowData.id === lastAddedRowId) {
							onDeleteNewAddedRow(rowData.id);
						} else {
							onRowDeleteClicked && onRowDeleteClicked(rowData);
						}
					}}
					// onClickHandler={() =>
					// 	onRowDeleteClicked && onRowDeleteClicked(params)
					// }
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
					rounded
				/>
			);
		};

		// console.log('rowsrowsrowsrowsrowsrowsrowsrowsrowsrows123456', rows)
		// console.log('employeeDraftListItems123456', employeeDraftListItems)

		const containerRef = useStickyDataTableHeader<HTMLDivElement>(
			[columns, rows],
			{
				navbarHeight: 112,
				// This page's frozen columns use PrimeReact's own frozen class plus
				// the local "selectionHeader" class for the checkbox column.
				frozenColumnSelector: ".p-frozen-column, .selectionHeader",
				selectionHeaderSelector: ".selectionHeader",
			}
		);
		return (
			<>
				{rows && provinceOfEmployementDDL && payFrequencyDDLItems ? (
					<div ref={containerRef}>
						<div className="card"

						>
							{/* <Box>
						<Toolbar
							sx={{ justifyContent: "end", paddingRight: "0!important" }}
						>
							
						</Toolbar>
					</Box> */}
							<DataTable
								value={
									rows && columns && rows && employeeDraftListItems
									// employeeDraftListData
								}
								responsiveLayout="scroll"
								lazy
								// filterDisplay="row"
								dataKey="id"
								// paginator
								// first={requestParams.first}
								// rows={requestParams.rows}
								// totalRecords={totalRecords}
								// onPage={onPage}
								// rowsPerPageOptions={rowsPerPageOptions}
								// paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
								// currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
								selection={selectedItems}
								onSelectionChange={onSelectionModelChange}
								editMode="cell"
								selectionMode={"checkbox"}
								// selectionMode="multiple"
								showGridlines
								resizableColumns
								columnResizeMode="expand"
								scrollable
								scrollHeight={tableScrollHeight ? "75vh" : ""}
								// scrollHeight="450px"
								// filterDisplay="menu"
								loading={isLoading ? isLoading : loading}
								// globalFilterFields={["headerName"]}
								header={searchFieldPlaceholder ? headerSearch : undefined}
								footer={footer ? footer : undefined}
								emptyMessage="No Record found."
								className="PrimeDataGridWithColumnToggled"
								style={{
									margin: `${tableMargin ? tableMargin : "14px 0 0.5rem 0"}`,
								}}
								sortMode="single"
								onSort={onSort}
							>
								{columns && (
									<Column
										selectionMode="multiple"
										hidden={!showChecboxColumn}
										frozen
										resizeable={false}
										style={{ width: "36px", textAlign: "center" }}
										field="selection"
										columnKey="selection"
										className="selectionHeader"
										headerClassName="selectionHeader"
									></Column>
								)}

								{columns &&
									columns
										.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
										.map((x: any, index: any) => {
											const editableFields = new Set([
												"employeeId",
												"firstName",
												"lastName",
												"initial",
												"gender",
												"socialInsuranceNumber",
												"address",
												"email",
												"phone",
												"country",
												"province",
												"city",
												"postCode",
												"zipCode",
												"stubLanguage",
												"emailStub",
												"printHourlyRateOnStub",
												"payFrequency",
												"payMethod",
												"provinceOfEmployment",
												"includeInT4OrRl1",
												"vacationPay",
												"dentalBenefits",
												"payOutVacationPay",
												"vacationPayOpenBalance",
												"howIsEmployPaid",
												"regularSalaryForThePeriod",



												"initials",
												"dateOfBirth",
												"dateOfHire",
											]);
											if (companyInformation?.paymentSetup === 100) {
												editableFields.delete("payMethod");
											}
											return (
												<Column
													key={index}
													field={x.field}
													header={x.headerName}
													headerTooltip={x.description}
													headerTooltipOptions={{ position: "top" }}
													hidden={x.hide}
													sortable={x.sortable}
													// resizable={x.resizable}
													dataType={x.type}
													align={x.align}
													alignHeader={x.headerAlign}
													// reorderable={x.disableReorder}
													exportable={x.disableExport}
													frozen={x.frozenColumn}
													alignFrozen={x.alignFrozen}
													columnKey={x.field}
													// sequence={x.sequence}
													style={{
														minWidth: x.minWidth,
														// minWidth: "10rem",
														fontSize: "0.875rem",
														maxWidth: x.maxWidth,
														// maxWidth: "15rem",
													}}
													headerStyle={{
														whiteSpace: whiteSpace ? whiteSpace : "nowrap",
													}}
													footer={x.footer}
													// body={(rowData: any, row: any) =>
													// 	columnsBody(rowData, row, x)
													// }
													editor={
														editableFields.has(x.field) ? cellEditor : undefined
													}
													onCellEditComplete={onCellEditComplete}
													body={(rowData: any, row: any) =>
														columnsBody(rowData, row, x)
													}
												/>
											);
										})}

								{rows && rows.length ? (
									<Column
										// body={() => deleteRowColumn(rowData)}
										body={(rowData: any, row: any) => deleteRowColumn(null, rowData, row)}
										header={setting}
										style={{
											width: "36px",
											// position: exportButtonInFileList ? "relative" : "sticky",
											// overflow: exportButtonInFileList ? "visible" : "hidden",
										}}
										hidden={!showSettingColumn}
										resizeable={false}
										reorderable={false}
										frozen
										alignFrozen="right"
										className="settingHeader"
										headerClassName="settingHeader"
									></Column>
								) : undefined}
							</DataTable>
						</div>
					</div>
				) : (
					<p>Data is loading...</p>
				)}
			</>
		);
	};

export default DraftEmployeeDataGrid;
